import { render, staticRenderFns } from "./edit-vendor-modal.vue?vue&type=template&id=6090cd7f"
import script from "./edit-vendor-modal.vue?vue&type=script&lang=js"
export * from "./edit-vendor-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports